import api from "./api";

export const getDemoShowcaseTemplates = async () => {
    const res = await api.get("/admin/demo-showcase/templates");
    return res.data;
};

export const getDemoShowcaseProjects = async () => {
    const res = await api.get("/admin/demo-showcase/projects");
    return res.data;
};

export const generateDemoShowcase = async (payload) => {
    const res = await api.post("/admin/demo-showcase/generate", payload);
    return res.data;
};

export async function deleteDemoShowcaseProjects(payload) {
    const response = await api.post(
        "/admin/demo-showcase/delete",
        payload
    );

    return response.data;
}